<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
    style="z-index: 1100 !important;"
  >

    <template v-slot:activator="{ props }">
      <div v-bind="props">
        <slot></slot>
      </div>
    </template>

    <v-card>
      <v-card-title class="d-flex justify-space-between">
        <span>
          {{ $t('routes.node.FCPImport') }}
        </span>

        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text v-if="assets.length === 0">
        <div class="bg-error" data-cy="">
          {{ $t('routes.node.FCPNoItems') }}
        </div>
      </v-card-text>

      <v-card-text>
        <div v-if="errorMessage" class="bg-error"> {{ errorMessage }}</div>
      </v-card-text>

      <v-card-text>
        <li v-for="asset in this.assets" v-bind:key="asset.id">
          {{ asset.name }}
        </li>
      </v-card-text>

        <v-card-text class="text-center">
          <v-progress-circular
            v-if="loading"
            indeterminate
            color="primary"
            :aria-label="$t('common.loading')"
          />
        </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" variant="flat" @click="addToFCP">{{ $t('common.import') }}</v-btn>
        <v-btn variant="text" @click="cancel">{{ $t('common.cancel') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { usePlayerStore } from '@/stores/PlayerStore.js'
import axios from 'axios';
import { parseSync } from 'subtitle';
import Helper from '@/components/helper.js';
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';
import DialogModel from '@/components/mixin/DialogModel.js';

export default {
  mixins: [DialogActionKeys, DialogModel],
  name: "FCPSubtitleDialog",
  props: {
    assets: {
      type: Array,
      required: true
    },
  },
  data: function() {
    return {
      loading: false,
      errorMessage: "",
    }
  },
  mounted: function() {
  },
  methods: {
    async addToFCP() {
      const subtitleStructures = [];
      this.loading = true;
      this.errorMessage = "";

      try {
        for (const asset of this.assets) {
          const subtitles = this.availableSubtitles.filter((s) => s.id === asset.id);

          if (subtitles && subtitles.length > 0) {
            const subtitle = subtitles[0];
            const subURL = subtitle.url;

            try {
              const res = await axios.get(subURL);
              const subs = parseSync(res.data);

              if (subs.length === 0) {
                this.errorMessage = this.$t('routes.pod.FCPCannotImportEmptyFile');;
                return;
              }

              const cues = [];
              for (let p = 0; p < subs.length; p++) {
                if (subs[p].type === 'cue') {
                  subs[p].id = p;
                  cues.push(subs[p]);
                }
              }

              this.sortCues(cues);
              const cuesData = cues.map((c) => c.data);
              subtitleStructures.push({
                "subtitles": cuesData,
                "name": asset.name
              });

            } catch (error) {
              console.log("Error fetching subtitle:", error);
              this.errorMessage = this.$t('routes.pod.FCPSubtitlesError');
              this.loading = false;
              return;
            }
          }
        }

        // All subtitles processed successfully
        if (subtitleStructures.length > 0) {
          const sessionObject = JSON.stringify({
            action: "addSubtitles",
            subtitleStructures: subtitleStructures
          });
          Helper.invokeFCPMessageHandler('subtitles', sessionObject);
          this.cancel();
        }
      } catch (error) {
        console.log("Unexpected error:", error);
        this.errorMessage = this.$t('routes.node.FCPSubtitlesError');
      } finally {
        this.loading = false;
      }
    },
    cancel: function() {
      this.dialog = false;
      this.errorMessage = "";
      this.loading = false;
    },
    sortCues: function(cues) {
      cues.sort(function(a, b) {
        if (a.data.start < b.data.start) return -1;
        if (a.data.start > b.data.start) return 1;
        return 0;
      });
    },

  },
  computed: {
    availableSubtitles: function() {
      const playerStore = usePlayerStore();
      return playerStore.availableSubtitles;
    },
  }
}
</script>

<style>

</style>
